import { Box, Button, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  featureGateMessages,
  featureMessageByKey,
  upgradeMessageByTier,
} from './featureGateMessages';

const TIER_FOR_FEATURE = {
  additionalQuestions: 'growth',
  branchingLogic: 'growth',
  audiences: 'growth',
  webTargeting: 'growth',
  dynamicFollowup: 'growth',
  integrations: 'growth',
  api: 'growth',
  autoTranslate: 'growth',
  sso: 'scale',
  auditLog: 'scale',
  autoTagging: 'scale',
  sms: 'scale',
  customRetention: 'scale',
};

function UpgradeCTA({ feature, fullPage }) {
  const { formatMessage } = useIntl();
  const tier = TIER_FOR_FEATURE[feature] || 'growth';
  const featureMessage = featureMessageByKey[feature] || featureGateMessages.featureFallback;
  const upgradeMessage = upgradeMessageByTier[tier] || featureGateMessages.upgradeGrowth;

  const content = (
    <Box sx={{ textAlign: 'center', py: fullPage ? 6 : 4, px: 3 }}>
      <Typography variant="h6" gutterBottom>
        <FormattedMessage id="FeatureGate.Title" defaultMessage="Upgrade to unlock this feature" />
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 480, mx: 'auto' }}>
        {formatMessage(featureMessage)}
      </Typography>
      <Button component={Link} to="/pricing" variant="contained" color="primary">
        {formatMessage(upgradeMessage)}
      </Button>
    </Box>
  );

  if (fullPage) {
    return <Paper sx={{ mt: 2 }}>{content}</Paper>;
  }

  return content;
}

UpgradeCTA.propTypes = {
  feature: PropTypes.string.isRequired,
  fullPage: PropTypes.bool,
};

UpgradeCTA.defaultProps = {
  fullPage: false,
};

export default UpgradeCTA;
